<template>
  <div class="home">
    <h1>Who's That Cosmere Character?</h1>
    <div class="actions">
      <Button to="/game/setup">
        Set up Game
      </Button>
      <Button>Submit clues</Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/widgets/Button.vue'

export default {
  name: 'Home',
  components: {
    Button
  }
}
</script>

<style scoped lang="scss">
.home {
  @include fill-screen;
}

h1 {
  font-family: 'Poetica', serif;
  text-transform: lowercase;
  font-size: 4rem;
  margin: 0 0 1rem;
}

.actions {
  display: grid;
  width: 300px;
  grid-template-columns: 0.5fr 0.5fr;
  grid-column-gap: 1rem;
}

.menu-bar {
  position: absolute;
  top: 1rem;
  right: 1rem;
  left: auto;
}
</style>
